var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckedOutlineIcon = function SvgCheckedOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.55,
    d: "m6.594 10.945 3.033 3.304 6.125-6.123m4.424 3.961a9.24 9.24 0 0 1-6.682 7.811 9.24 9.24 0 0 1-7.03-.844 9.24 9.24 0 0 1-4.642-9.172 9.243 9.243 0 0 1 18.354 2.205",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgCheckedOutlineIcon;